// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__UQy4v","tab_item":"styles_tab_item__xfHRM","tab_item__active":"styles_tab_item__active__22FAc"};